Object.defineProperty(exports, '__esModule', { value: true });

const index = require('../index.js');
const pack = require('../packer/pack.js');
const unpack = require('../packer/unpack.js');
const index$1 = require('../plugins/console/record/index.js');
const index$2 = require('../plugins/console/replay/index.js');
const index$3 = require('../record/index.js');
const types = require('../types.js');
const index$4 = require('../replay/index.js');
const utils = require('../utils.js');



exports.addCustomEvent = index.addCustomEvent;
exports.freezePage = index.freezePage;
exports.pack = pack.pack;
exports.unpack = unpack.unpack;
exports.PLUGIN_NAME = index$1.PLUGIN_NAME;
exports.getRecordConsolePlugin = index$1.getRecordConsolePlugin;
exports.getReplayConsolePlugin = index$2.getReplayConsolePlugin;
exports.record = index$3.default;
Object.defineProperty(exports, 'EventType', {
	enumerable: true,
	get: () => types.EventType
});
Object.defineProperty(exports, 'IncrementalSource', {
	enumerable: true,
	get: () => types.IncrementalSource
});
Object.defineProperty(exports, 'MouseInteractions', {
	enumerable: true,
	get: () => types.MouseInteractions
});
Object.defineProperty(exports, 'ReplayerEvents', {
	enumerable: true,
	get: () => types.ReplayerEvents
});
exports.Replayer = index$4.Replayer;
Object.defineProperty(exports, 'mirror', {
	enumerable: true,
	get: () => utils._mirror
});
exports.utils = utils;
//# sourceMappingURL=all.js.map
